export const official_website = process.env.VUE_APP_URL_TEST;